export const IGetAnalyticEventParamsUseCaseType = Symbol('IGetAnalyticEventParamsUseCase');
